import { MarketplaceIncentive } from '@carvana/merch-contracts';
import { VehiclePrice } from '@carvana/merch-contracts';
import resolveIncentives from './resolveIncentives';

export type NormalizedIncentives = {
  additionalIncentives?: {
    amount: number;
    incentives: MarketplaceIncentive[];
  };
  appliedIncentives?: {
    amount: number;
    incentives: MarketplaceIncentive[];
  };
};

export default function normalizeIncentives(
  price: Partial<VehiclePrice> | undefined
): NormalizedIncentives {
  if (!price) return {};

  const {
    additionalIncentives = [],
    appliedIncentives = [],
    appliedIncentivesAmount,
    marketplaceIncentives = [],
    additionalIncentivesAmount
  } = price;

  return {
    additionalIncentives: additionalIncentivesAmount
      ? {
          amount: additionalIncentivesAmount,
          incentives: resolveIncentives(
            additionalIncentives,
            marketplaceIncentives
          )
        }
      : undefined,
    appliedIncentives: appliedIncentivesAmount
      ? {
          amount: appliedIncentivesAmount,
          incentives: resolveIncentives(
            appliedIncentives,
            marketplaceIncentives
          )
        }
      : undefined
  };
}
